export default __webpack_public_path__ + "img/qfAFkFIG.767e7403.svg";